import cx from 'classnames';
import React from 'react';
import styles from './LoadingPlaceholder.mscss';

interface OwnProps {
    className?: string;
    width: number | string;
    height?: number | string;
    style?: any;
    children?: React.ReactChild;
}

const LoadingPlaceholder: React.StatelessComponent<OwnProps> = ({ className, width, height, style, children }) => (
    height && height !== '100%' ? (
        <div className={cx(className, styles.LoadingPlaceholderParent)}>
            <div className={styles.LoadingPlaceholder} style={{ ...style, width, height }} children={children}/>
        </div>
    ) : (
        <div className={cx(className, styles.LoadingPlaceholder)} style={{ ...style, width, height }}/>
    )
);

export default LoadingPlaceholder;
